import * as React from "react";
import { EventCard } from "../../../components";
import * as RenderMethods from "./RenderMethods";
import { marketColumnsDisplay } from "../../../../../constants";
import { ContainerQuery } from "react-container-query";
import { observer } from "mobx-react";
const ContainerQueryObserver = observer(ContainerQuery);
export class Multiview extends EventCard {
    constructor(props) {
        super(props);
        this.renderEventCardDetails = RenderMethods.renderEventCardDetailsMultiview;
        this.renderMarkets = RenderMethods.renderMarketsMultiview;
        this.renderBetButtons = RenderMethods.renderBetButtonsMultiview;
        this.cardTypeClass = `rj-ev-list__${this.componentPrefix}--multiview`;
        this.buttonsHolderClass = `rj-ev-list__${this.componentPrefix}__buttons-holder--multiview`;
    }
    render() {
        return (React.createElement(ContainerQueryObserver, { query: marketColumnsDisplay }, (params) => (React.createElement("div", { className: this.setClasses(), "data-uat": `div-ev-list-${this.componentPrefix}` },
            React.createElement("div", { className: `rj-ev-list__${this.componentPrefix}__inner`, "data-uat": `div-ev-list-${this.componentPrefix}-inner` },
                this.renderEventCardDetails(this.getCardDetailsParams(this.props), this.componentPrefix),
                this.renderMarkets(this.props, this.buttonsHolderClass, this.componentPrefix, params),
                this.renderMarketsCountLink(this.getCountLinkParams(this.props), this.componentPrefix))))));
    }
}
//# sourceMappingURL=Multiview.js.map